export const getCandidateNonAgentInterviews = (api, payload, tokenType) => {
  const { id, departmentId, designationId } = payload;
  return api.get(
    `/competencyInterviewSetUp/competencyAllInterview/designationId/${designationId}/departmentId/${departmentId}/candidate/${id}`,
    { tokenType },
  );
};

export const getCandidateAgentInterviews = (api, payload, tokenType) => {
  const { id } = payload;
  return api.put(
    `/interviews`,
    {
      candidate: id,
    },
    { tokenType },
  );
};

export const getAllInterviewStatus = async (api, tokenType) => {
  return api.get(`/statusParametersMaster`, {
    tokenType,
  });
};
